var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helper-text"},[_c('i',{staticClass:"el-icon-info"}),_c('span',{staticClass:"ml-5"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }